import { Record } from 'immutable';

const SnapshotIntegrationsRecord = Record({
  bank: null,
  publicAccounting: '',
  privateAccounting: '',
  connectionStatus: '',
});

export default class SnapshotIntegrations extends SnapshotIntegrationsRecord {
  static deserialize(jsonObject = {}) {
    return new SnapshotIntegrations(jsonObject);
  }
}
